<script setup>
import { useAppStore } from '@/store/main'

defineProps({
  back: {
    type: Boolean,
    default: true,
  },
  backMenu: {
    type: Boolean,
    default: false,
  },
})

const store = useAppStore()
const { getBack, getRootMenu } = storeToRefs(store)
const { setLayer, setLayerId, setShowMenuLayer, setRootMenu } = store

const getClose = computed(() => {
  switch (getRootMenu.value) {
    case 'studium':
      return 'close--studium'
    case 'akademie':
      return 'close--akademie'
    case 'program':
      return 'close--program'
    default:
      return ''
  }
})

const close = () => {
  setLayer(0)
  setLayerId('')
  setShowMenuLayer(false)
  setRootMenu('')
}

const goMenuBack = () => {
  switch (getRootMenu.value) {
    case 'studium':
      setLayer(0)
      break
    case 'akademie':
      setLayer(1)
      break
    case 'program':
      setLayer(2)
      break
  }
}

onMounted(() => {
  window.addEventListener('keydown', (e) => {
    if (e.code === 'Escape') {
      close()
    }
  })
})
</script>

<template>
  <div class="navigation">
    <div>
      <div v-if="back" class="navigation__box">
        <RowLink
          :id="getBack?.id"
          :label="getBack?.label"
          :slug="getBack?.slug"
          :content-type="getBack?.contentType"
          :root="getBack?.root"
          :name="getBack?.name"
          :back="back"
          role="back"
          aria-label="Close"
        />
      </div>
      <button
        v-if="backMenu"
        class="navigation__box"
        tabindex="0"
        @click="goMenuBack"
        @keyup.enter="goMenuBack"
      >
        <NuxtLink to="#" class="arrowbox">
          <i class="arrow left"></i>
        </NuxtLink>
      </button>
    </div>

    <div v-if="!back" class="navigation__box">
      <button
        class="close"
        :class="getClose"
        tabindex="0"
        aria-label="Close"
        @click="close"
        @keyup.enter="close"
      ></button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 14px;
  margin: 41px 0 37px 0;

  &__box {
    position: relative;
    min-width: 30px;
    min-height: 30px;
    background: transparent;
  }
}

.close {
  position: absolute;
  width: 30px;
  height: 30px;
  opacity: 1;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.close--studium:before,
.close--studium:after {
  background-color: $color-red;
}
.close--akademie:before,
.close--akademie:after {
  background-color: $color-green;
}
.close--program:before,
.close--program:after {
  background-color: $color-blue;
}
.close:before,
.close:after {
  position: absolute;
  right: 13px;
  top: 2px;
  content: ' ';
  height: 22px;
  width: 2px;
  transition: background-color 0.3s;
}
.close:hover::before,
.close:hover::after {
  background-color: $color-2;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

.arrowbox {
  padding-left: 5px;
  width: 30px;
  &:hover {
    .arrow {
      border-color: $color-2;
    }
  }
}
.arrow {
  border: solid $color-4;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 5px;
}
.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}
</style>
